export default __webpack_public_path__ + "static/media/NotFound.3e2b3139.gif";